import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {catchError, throwError} from 'rxjs';
import {stopLoading} from '../../../store/layout/layout.action';
import {SharedUtils} from "../../services/utils/shared-utils.service";
import {logout} from "../../../store/auth/auth.action";
import {MessageUtilsService} from "../../services/utils/message-utils.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);

  return next(req).pipe(
    catchError((error) => {
      console.error('HTTP error:', error);
      store.dispatch(stopLoading());

      switch (error.status) {
        case 401:
          localStorage.clear();
          window.location.href='/auth';
          break;

        case 403:
          const delay = 3000;
          SharedUtils.instance()?.messageUtils()?.push(MessageUtilsService.Severity.denied);
          if(SharedUtils.instance()?.currentUser()?.currentUserValue?.id) {
            setTimeout(() => window.location.href = '/app', delay);
          } else {
            setTimeout(() => store.dispatch(logout()), delay);
          }
          break;

        case 404:
          window.location.href='/app';
          break;

        default:
          console.error('unhandled error:', error.message);
          break;
      }

      return throwError(() => error);
    })
  );
};


